import { apiClient } from '@/services/api';
import type { UserSnippet } from '@/types/referral';

export interface SnippetsListResponse {
  snippets: UserSnippet[];
}

export interface SnippetCreateInput {
  body: string;
}

export const snippetsService = {
  /** GET /api/v1/snippets — current user's saved message templates, recent_first. */
  async list(): Promise<UserSnippet[]> {
    const response = await apiClient.get<SnippetsListResponse>('/api/v1/snippets');
    return response.snippets;
  },

  /** POST /api/v1/snippets — save a new template. Returns the persisted snippet. */
  async create(input: SnippetCreateInput): Promise<UserSnippet> {
    const response = await apiClient.post<{ snippet: UserSnippet }>(
      '/api/v1/snippets',
      input,
    );
    return response.snippet;
  },

  /** DELETE /api/v1/snippets/:id — soft-removes the template (no recovery). */
  async remove(id: number): Promise<void> {
    await apiClient.del(`/api/v1/snippets/${id}`);
  },
};
